import { render, staticRenderFns } from "./CartBlock.vue?vue&type=template&id=6fd3e467&"
import script from "./CartBlock.vue?vue&type=script&lang=js&"
export * from "./CartBlock.vue?vue&type=script&lang=js&"
import style0 from "./CartBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports